const faqs = [
  {
    q: '51吃瓜黑料是什么网站？',
    a: '51吃瓜黑料是一个集结全网网红塌房黑料、明星爆料、网曝门事件与博主反差记录的娱乐资讯聚合平台。网站不打烊持续更新，为用户提供最新最全的吃瓜内容与爆料合集。',
  },
  {
    q: '51吃瓜黑料的内容多久更新一次？',
    a: '51吃瓜黑料保持24小时不打烊更新机制，编辑团队全天候追踪全网热门话题。从网红塌房到每日大赛现场，一旦有新的黑料或爆料出现，网站会在第一时间整理发布，确保你不错过任何精彩内容。',
  },
  {
    q: '可以在手机上访问51吃瓜黑料吗？',
    a: '当然可以！51吃瓜黑料网址入口全面适配移动端浏览器，在手机上直接访问即可获得流畅的浏览体验。所有51吃瓜黑料在线观看功能和视频入口均在移动端完美呈现。',
  },
  {
    q: '51吃瓜黑料的内容来源可靠吗？',
    a: '51吃瓜黑料的内容来源于全网公开信息与用户投稿整理，所有爆料均标注信息来源。我们致力于为吃瓜爱好者提供一个信息聚合平台，但对于爆料内容的真实性建议读者自行判断，本站内容仅供娱乐参考。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-secondary-500"></div>
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
            常见问题
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </h3>
                <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform duration-200 text-lg flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}